import { prepareClientPhotos } from "./prepareClientPhotos";
import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;

const multipartHeaders = () => {
  const configuredHeaders = authHeader({ contentType: "multipart/form-data" }) || {};
  const headers = { ...configuredHeaders };
  delete headers["Content-Type"];
  return headers;
};

const create = async (values) => {
  let photos;
  try {
    photos = await prepareClientPhotos(values.myFiles);
  } catch (error) {
    throw { response: { status: 422, data: { message: error.message } } };
  }
  const formData = new FormData();
  for (let value in values) {
    if (value === "client_id") continue;
    if (["myFiles"].includes(value) && values[value] && typeof values[value] === "object") {
      photos.forEach((photo) => {
        formData.append("photo", photo);
      });
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/clientphoto/store";
  formData.append("client_id", values.client_id);
  return axios.post(API_URL + action, formData, { headers: multipartHeaders() });
};

// Keep migrated gallery identities distinct from new uploads with the same ID.
const validPhotoReference = (id, allowAvatar = false) => {
  if (typeof id !== "string" && typeof id !== "number") return false;
  const match = String(id).match(/^(?:(legacy|avatar)-)?([1-9][0-9]*)$/);
  return Boolean(match && (allowAvatar || match[1] !== "avatar") && Number.isSafeInteger(Number(match[2])));
};

const invalidPhotoReference = () => Promise.reject(new Error("A valid client photo id is required."));

const update = (values) => {
  if (!validPhotoReference(values.id)) return invalidPhotoReference();
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/clientphoto/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  formData.append("client_id", values.client_id);
  return axios.post(API_URL + action, formData, { headers: multipartHeaders() });
};

const view = (values = {}) => {
  const request = buildClientHistoryListRequest("afterlogin/clientphoto/view", values);
  if (typeof values.id === "string" && values.id.startsWith("legacy-")) {
    if (!validPhotoReference(values.id)) return invalidPhotoReference();
    request.body.id = values.id;
    request.body.pagination = false;
  }
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const content = ({ id, signal } = {}) => {
  if (!validPhotoReference(id, true)) return invalidPhotoReference();
  const action = `afterlogin/clientphoto/content/${id}`;
  return axios.get(API_URL + action, {
    headers: authHeader(),
    responseType: "blob",
    signal,
  });
};

const deleted = (values) => {
  if (!validPhotoReference(values.id)) return invalidPhotoReference();
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/clientphoto/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const clientphotoApiController = {
  create,
  update,
  view,
  content,
  deleted,
};
export default clientphotoApiController;
